import type { TravelQuery } from "@goblin/domain";
import { useState } from "react";
import { QueryBuilder, type SubmitOpts } from "./QueryBuilder/QueryBuilder";
import { ResultsStream } from "./Results/ResultsStream";

type Submission = { query: TravelQuery; opts: SubmitOpts; ts: number };

export function SearchPage() {
  const [submission, setSubmission] = useState<Submission | null>(null);

  return (
    <div className="space-y-8">
      <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-slate-100">
          Armá tu búsqueda
        </h2>
        <p className="mb-4 text-sm text-slate-600 dark:text-slate-400">
          Cada campo acepta desde muy específico (un aeropuerto, una fecha exacta) hasta muy vago
          (una región, un mes, "unas dos semanas"). Los <em>trade-offs</em> te dejan decirle al
          motor cosas como "solo aceptá una escala extra si el precio baja un 15%".
        </p>
        <QueryBuilder onSubmit={(query, opts) => setSubmission({ query, opts, ts: Date.now() })} />
      </section>

      {submission && (
        <section>
          <ResultsStream
            key={submission.ts}
            query={submission.query}
            useRealPrices={submission.opts.useRealPrices}
          />
        </section>
      )}
    </div>
  );
}
